export var createWindow = function createWindow() {
  return typeof window === 'undefined' ? null : window;
};